import ChatNotification from './ChatNotification';

export default ChatNotification;
